// action - customization reducer
export const SET_MENU = '@customization/SET_MENU';
export const MENU_TOGGLE = '@customization/MENU_TOGGLE';
export const MENU_OPEN = '@customization/MENU_OPEN';
export const SET_FONT_FAMILY = '@customization/SET_FONT_FAMILY';
export const SET_BORDER_RADIUS = '@customization/SET_BORDER_RADIUS';

export const FETCH_PERMISSIONS_REQUEST = '@permissions/FETCH_PERMISSIONS_REQUEST';
export const FETCH_PERMISSIONS_SUCCESS = '@permissions/FETCH_PERMISSIONS_SUCCESS';
export const FETCH_PERMISSIONS_FAILURE = '@permissions/FETCH_PERMISSIONS_FAILURE';
export const CLEAR_PERMISSIONS = '@permissions/CLEAR_PERMISSIONS';